export function getFinanceiroTabs(t, showAccountsPayable = true) {
    return [
        { title: t('financeiro.tabs.accounts-receivable'), route: '/financeiro/contas-a-receber' },
        ...(showAccountsPayable
            ? [{ title: t('financeiro.tabs.accounts-payable'), route: '/financeiro/contas-a-pagar' }]
            : []),
        { title: t('financeiro.tabs.other-accounts'), route: '/financeiro/outras-contas' },
        { title: t('financeiro.tabs.dunning-rules'), route: '/financeiro/regua' },
    ];
}
